import { Injectable } from '@angular/core';
import * as _filesaver from 'file-saver';
// import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiResponse } from '../models/api-response.model';
import { AuthService } from './auth.service';
import { BannerLocation } from '../models/marketing.model';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const IMAGE_TYPE = 'image/png';
const PDF_TYPE = 'application/pdf';
const CSV_TYPE = 'application/csv';
const JSON_TYPE = 'application/json';
const ZIP_TYPE = 'application/zip';

@Injectable()
export class FileService {

    constructor(private http: HttpClient,
        private authService: AuthService) { }

    exportCartToExcel(cartId: string): Observable<any> {
        return this.http.get('/api/ExportExcel/exportcarttoexcel?cartId=' + cartId,
        { responseType: 'blob', headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'} })
            .pipe(catchError(this.authService.handleError));
    }

    exportAllCartsToExcel(): Observable<any> {
        return this.http.get('/api/ExportExcel/exportallcartstoexcel',
        { responseType: 'blob', headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'} })
            .pipe(catchError(this.authService.handleError));
    }

    saveFile(url: string): Observable<any> {
        return this.http.get<Blob>(url, { responseType: 'blob' as 'json' })
            .pipe(catchError(this.authService.handleError));
    }

    SendCartAsEmail(cartId: number, sendReason: string, contactEmail: string): Observable<ApiResponse> {
        return this.http.get<ApiResponse>('/api/exportexcel/sendcartasemail?cartId=' + cartId
            + '&sendReason=' + sendReason
            + '&contactEmail=' + contactEmail)
            .pipe(catchError(this.authService.handleError));
    }

    DownloadFile(file: string, fileName: string, displaySaveAs: boolean): Observable<any> {
        return this.http.get('api/Catalogue/Download?file=' + file
            + '&fileName=' + fileName
            + '&displaySaveAs=' + displaySaveAs, { responseType: 'blob' as 'json' })
            .pipe(catchError(this.authService.handleError));
    }

    exportPromotionListReport( analyticsType: string, startDate: string, endDate: string , locationId?: any, promotionId?: number): Observable<any> {
        return this.http.get('/api/ExportExcel/ExportPromotionAnalytics?analyticsType=' + analyticsType + '&locationId=' + locationId  + '&startDate=' + startDate + '&endDate=' + endDate + '&promotionId=' + promotionId,
        { responseType: 'blob', headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'} })
        .pipe(catchError(this.authService.handleError));
    
    }

    exportInvoiceListZip(invoices: string):Observable<any> {
        let formData = new FormData();

        formData.append('invoicesString', invoices);

        return this.http.post('/api/MyOrder/DownloadBulkInvoices', formData, {responseType: 'blob', headers: {'Accept': 'application/zip'}}).pipe(catchError(this.authService.handleError));
    }
 b  

    // public exportAsExcelFile(json: any[], excelFileName: string): void {

    //     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    //     const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    //     const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    //     this.saveAsExcelFile(excelBuffer, excelFileName);
    // }

    // public exportAsCSVFile(json: any[], csvFileName: string): void {

    //     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    //     const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    //     const excelBuffer: any = XLSX.write(workbook, { bookType: 'csv', type: 'array' });

    //     this.saveAsCSVFile(excelBuffer, csvFileName);
    // }

    saveAsExcelFile(buffer: any, fileName: string): void {

        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });

        _filesaver.saveAs(data, fileName);
    }

    saveAsImageFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: IMAGE_TYPE
        });

        _filesaver.saveAs(data, fileName);
    }

    saveAsPdf(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: PDF_TYPE
        });

        _filesaver.saveAs(data, fileName);
    }

    saveAsCSVFile(buffer: any, fileName: string): void {

        const data: Blob = new Blob([buffer], {
            type: CSV_TYPE
        });

        _filesaver.saveAs(data, fileName);
    }

    saveAsJSONFile(buffer: any, fileName: string): void {

        const data: Blob = new Blob([buffer], {
            type: JSON_TYPE
        });

        _filesaver.saveAs(data, fileName);
    }

    saveAsZIPFile(buffer: any, fileName: string): void {

        const data: Blob = new Blob([buffer], {
            type: ZIP_TYPE
        });

        _filesaver.saveAs(data, fileName);
    }
}
